import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Favorites from "@/pages/Favorites";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPropertyForm from "@/pages/AdminPropertyForm";
import AdminUsers from "@/pages/AdminUsers";
import { AuthProvider, AuthCallback, RequireAdmin } from "@/auth";

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  // Detect Emergent OAuth callback (session_id in hash) BEFORE routing
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ilanlar" element={<Properties />} />
        <Route path="/ilan/:slug" element={<PropertyDetail />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/favorilerim" element={<Favorites />} />
        <Route path="/admin/giris" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
        <Route path="/admin/ilan/yeni" element={<RequireAdmin><AdminPropertyForm /></RequireAdmin>} />
        <Route path="/admin/ilan/:id" element={<RequireAdmin><AdminPropertyForm /></RequireAdmin>} />
        <Route path="/admin/yoneticiler" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
      <Toaster position="top-right" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
